import { Component } from 'react'
import { 
    FacebookShareButton, 
    TwitterShareButton, 
    LinkedinShareButton,
    FacebookIcon, 
    TwitterIcon, 
    LinkedinIcon
} from 'react-share'
import { Caption } from '../../Nodes/Typography'
import CustomIcon from '../../Nodes/CustomIcon'
import Snackbar from '../../Widgets/Snackbar'
import Button from '../../Nodes/Button'
import { copyToClipboard } from '../../../utilities'

class Share extends Component {
    static defaultProps = {
        url: 'https://canadiandiscovery.com',
        title: ''
    }

    state = {
        snackbarOpen: false
    }

    handleClipboardClick = () => {
        copyToClipboard(this.props.url)
        this.setState({ snackbarOpen: true }, () => {
            setTimeout(() => {
                this.setState({ snackbarOpen: false })
            }, 3000);
        })
    }

    render() {
        const { url, title } = this.props

        return (
            <div className="share">
                <span className="share__icon share__icon--copy">
                    <Button raised onClick={this.handleClipboardClick} title="Copy url to clipboard">
                        <CustomIcon>copy</CustomIcon>
                        <Caption>Copy</Caption>
                    </Button>
                </span>
                <span className="share__icon share__icon--facebook">
                    <FacebookShareButton url={url} quote={title}>
                        <FacebookIcon size={24} round />
                        <Caption>Share</Caption>
                    </FacebookShareButton>
                </span>
                <span className="share__icon share__icon--linkedin">
                    <LinkedinShareButton url={url} source={url} title={title}>
                        <LinkedinIcon size={24} round />
                        <Caption>Share</Caption>
                    </LinkedinShareButton>
                </span>
                <span className="share__icon share__icon--twitter">
                    <TwitterShareButton url={url} title={title} via="CdnDiscovery" >
                        <TwitterIcon size={24} round />
                        <Caption>Tweet</Caption>
                    </TwitterShareButton>
                </span>
                <Snackbar 
                    open={this.state.snackbarOpen}
                    onClose={() => this.setState({ snackbarOpen: false })}>
                    Copied to clipboard
                </Snackbar>
            </div>
        )
    }
}

export default Share

